<template>
  <div class="quote-price-quotation-list">
    <div v-if="data.length === 0">No PDFs</div>
    <ul v-else>
      <h3>Submissions</h3>
      <li v-for="(item, index) in data" :key="index" @click="handlePoplatePDF(item)">
        <a href="#">{{ item.updated_at }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'QuotePdfList',
  props: {
    quoteId: {
      type: Number,
      required: true
    },
    pdfData: {
      type: Object
    }
  },
  data () {
    return {
      data: []
    }
  },
  mounted () {
    this.loadPdfList()
  },
  computed: {
    lastDocumentData () {
      return this.data[this.data.length - 1]
    }
  },
  methods: {
    ...mapActions([
      'getPDFList'
    ]),
    handlePoplatePDF(pdfData) {
      this.$emit('onPopulate', pdfData)
    },
    getLastDocumentData () {
      return this.lastDocumentData
    },
    loadPdfList() {
      this.getPDFList(this.quoteId).then(resp => {
        this.data = resp.data
        this.$emit('onSetDefaultDocument', this.lastDocumentData)
      })
    }
  }
}
</script>

<style>

</style>
